import * as R from 'ramda'

export function getAuthRoute(routeList) {
  if (!routeList) return ''
  const bus = R.find(bus => bus.open)($store.getters.buses || [])
  const route = R.find((item) => {
    return item.meta?.tp === bus.tp
  })(routeList || [])
  return route ? route.name : ''
}

export function isAuthRouter(to) {
  console.log('to==>', to)
  const bus = R.find(bus => bus.tp === to.meta.group)($store.getters.buses || [])
  return bus ? bus.open : $store.getters.isSuper
}
